import React from 'react';
import './Main.css';

export default props => {
  return (
    <main className="main">
      <div className="main-content">{props.children}</div>
    </main>
  );
};



// WEBPACK FOOTER //
// ./src/components/Main.js